import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as approvalApi from '../../lib/api/approval';

const [VIEW_APPROVAL, VIEW_APPROVAL_SUCCESS, VIEW_APPROVAL_FAILURE] =
  createRequestActionTypes('user/VIEW_APPROVAL');
export const viewApproval = createAction(VIEW_APPROVAL, (id) => id);
const viewApprovalSaga = createRequestSaga(
  VIEW_APPROVAL,
  approvalApi.getApproval,
);

const UNLOAD_APPROVAL = 'user/UNLOAD_APPROVAL';
export const unloadApproval = createAction(UNLOAD_APPROVAL);

const SET_APPROVAL = 'user/SET_APPROVAL';
export const setApproval = createAction(SET_APPROVAL, (user) => user);

export function* approvalSaga() {
  yield takeLatest(VIEW_APPROVAL, viewApprovalSaga);
}

const initialState = {
  approval: null,
  prjUuid: null,
  roUuid: null,
  error: null,
};

const approval = handleActions(
  {
    [VIEW_APPROVAL_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      approval: data?.info,
      prjUuid: data?.prjUuid,
      roUuid: data?.roUuid,
    }),
    [VIEW_APPROVAL_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_APPROVAL]: () => initialState,
    [SET_APPROVAL]: (state, { payload: approval }) => ({
      ...state,
      approval: approval,
    }),
  },
  initialState,
);

export default approval;
